import { Flex, Link, Text } from "@radix-ui/themes";
import { FC } from "react";
import { Modal } from "../../components";
import { DataPrivacy } from "./dataPrivacy";
import { Imprint } from "./imprint";
import "./index.css";

export const Footer: FC = () => {
  return (
    <Flex justify="center" gap="2" wrap="wrap">
      <Modal
        trigger={<div className="footer--trigger">{"Impressum"}</div>}
        title={"Impressum"}
      >
        <Imprint />
      </Modal>
      <Modal
        trigger={<div className="footer--trigger">{"Datenschutz"}</div>}
        title={"Datenschutz"}
      >
        <DataPrivacy />
      </Modal>
      <div
        className="footer--trigger"
        onClick={() =>
          window.open(
            "https://res.cloudinary.com/alexander-buerkle/image/upload/v1730733621/Webseite/AGB/ab/Allgemeine-Lieferbedingung_Alexander-Buerkle_Stand-November-2024.pdf",
            "_blank",
          )
        }
      >
        AGB
      </div>
    </Flex>
  );
};
